import Input from './_src/input.vue'
Input.install = function(Vue) {
  Vue.component(Input.name, Input)
}
export default Input